import * as semver from 'semver'
import {EnvSetup} from "enums/Envs";

export enum Apps {
    Instinct = 'Instinct',
    Bloom = 'Bloom',
    Flava = 'Flava',
    Spark = 'Spark',
}

export enum AppIds {
    Instinct = 1,
    Flava = 2,
    Spark = 6
}

export const AppNumberToEnum: Record<number, Apps> = {
    [AppIds.Instinct]: Apps.Instinct,
    [AppIds.Flava]: Apps.Flava,
    [AppIds.Spark]: Apps.Spark,
}

export const AppsUrls = {
    [Apps.Instinct]: 'https://api.brightou.com/',
    [Apps.Bloom]: 'https://api.bloomdates.com/',
    [Apps.Flava]: 'https://api.flava.app/',
    [Apps.Spark]: 'https://api.sparkdate.app/',
};

export const AppUrlsTest = {
    [Apps.Instinct]: 'https://api-test.instinctdate.app',
    [Apps.Bloom]: 'https://api-test.bloomdates.com/',
    [Apps.Flava]: 'https://api-test.flava.app/',
    [Apps.Spark]: 'https://api-test.sparkdate.app/',
}

export const AppNames: Record<number, string> = {
    0: 'Unkown',
    1: 'Instinct',
    2: 'Flava',
    3: 'Bloom',
    6: 'Spark',
    7: 'Rose',
    8: 'Eros',
};

export const AppEmojis: Record<number, string> = {
    0: '',
    1: '💛',
    2: '❤️‍🔥',
    3: '🌸',
    6: '✨',
    7: '🌹',
    8: '🏹',
};

export const doesNeedAppInfo = (app: Apps) => {
    return app === Apps.Instinct
}

export const areQuestionsSupported = (app: Apps) => app === Apps.Spark;

export const isRequiredVerificationSupprted = (app: Apps, version: string) => {
    if (app === Apps.Flava) {
        return true
    } else if (app === Apps.Instinct) {
        return true;
    } else {
        return false
    }
}

export const isWatermarkSupported = (app: Apps, version: string) => {
    if (app === Apps.Flava) {
        return version && semver.gt(version, '1.6.42')
    } else if (app === Apps.Instinct) {
        return version && semver.gte(version, '7.2.8')
    } else {
        return false
    }
}

export const isBoostAndSparksGiftsSupported = (app: Apps) => {
    return app === Apps.Flava || app === Apps.Instinct || app === Apps.Spark;
}

export const isDeleteProfileAndGiftsSupported = (env: EnvSetup) => {
    return true;
}

export const areBoostsAvailable = (app: Apps) => {
    return app === Apps.Instinct || app === Apps.Flava;
}


export const areGreetingsAvailable = (app: Apps) => {
    return app === Apps.Instinct;
}

export const isModerationPackAvailable = (env?: EnvSetup) => {
    return env?.app === Apps.Instinct || env?.app === Apps.Flava || env?.app === Apps.Spark
}

export const isShadowBanSupported = (env?: EnvSetup) => {
    return env?.app === Apps.Flava || env?.app === Apps.Instinct || env?.app === Apps.Spark;
}

export const isNoFaceButtonSupported = (env?: EnvSetup) => {
    return env?.app === Apps.Instinct || env?.app === Apps.Flava
}

export const isDeleteAllAvailable = (env?: EnvSetup) => {
    return env?.app === Apps.Instinct || env?.app === Apps.Flava || env?.app === Apps.Spark;
}

export const isPatternsManagementSupported = (env?: EnvSetup) => {
    return (env?.app === Apps.Flava || env?.app === Apps.Instinct || env?.app === Apps.Spark);
}

export const isShowHideAboutSupported = (env?: EnvSetup) => {
    return (env?.app === Apps.Flava || env?.app === Apps.Spark || env?.app === Apps.Instinct);
}


export const hasAIPhotos = (env?: EnvSetup) => {
    return true;
}

export enum SubscriptionTypes {
    Basic = 'Basic',
    Plus = 'Plus',
    Prime = 'Prime',
    Infinity = 'Infinity',
}

export const AppSubscriptionTypes: Partial<Record<Apps, SubscriptionTypes[]>> = {
    [Apps.Instinct]: [SubscriptionTypes.Basic, SubscriptionTypes.Plus, SubscriptionTypes.Prime],
    [Apps.Spark]: [SubscriptionTypes.Plus, SubscriptionTypes.Prime],
    [Apps.Flava]: [SubscriptionTypes.Plus, SubscriptionTypes.Infinity],
}
